import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useAudienceStore } from "@/lib/stores/audienceStore";
import { useAuthStore } from "@/lib/stores/authStore";

export type ChildRouteContext = {
  audience: "child";
};

export const Route = createFileRoute("/(content)/children")({
  beforeLoad: () => {
    const { audience } = useAudienceStore.getState();
    const { user } = useAuthStore.getState();

    if (user && user.audience) {
      if (user.audience !== "CHILD") {
        throw redirect({
          to: "/adults/exercises",
        });
      }
    } else if (!audience) {
      throw redirect({
        to: "/audience",
      });
    } else if (audience === "ADULT") {
      throw redirect({
        to: "/adults/exercises",
      });
    }

    return {
      audience: "child" as const,
    } satisfies ChildRouteContext;
  },
  component: ChildrenLayout,
});

function ChildrenLayout() {
  return <Outlet />;
}
